import Temp from '@/courier/Temp'

export default class FlashExpress extends Temp {

    static CODE = 'FLE';

    constructor() {
        super( FlashExpress.CODE ); 
    }

    listPostcodeSpecial = JSON.parse( localStorage.getItem('courier_postcode') )

    static TYPE_SAME_PROVINCE_NOT_BKK = 'SAME_PROVINCE_NOT_BKK'
    static RULE_DIMENSION_WEIGHT = {
        'SAME_PROVINCE_NOT_BKK': {
          'max_weight': 19001,
          'max_dimension': 220
        }
    }
    getZone( item ){
        let type , from , to
        let cross_price = 0
        let remote_area = 0

        remote_area = super.checkRemoteArea( Number(item.toPostcode) );
        
        let prefixFromPostCode = item.fromPostcode.toString().substring( 0 , 2 )
        let prefixToPostCode = item.toPostcode.toString().substring( 0 , 2 )
    
        // เฉพาะตอนโปร 9.9 FLE ถึง 27/12/2020
        if( Object.keys(item.courierRates).length < 2 ){
          from = null
          to = null
        }else{
          from = super.checkZone( prefixFromPostCode )
          to = super.checkZone( prefixToPostCode )
        }

        if( ['94','95','96'].indexOf( prefixToPostCode ) > -1 ){
          remote_area = this.listPostcodeSpecial[FlashExpress.CODE].remotearea.special.cost
        }

        if( ['94','95','96'].indexOf( prefixToPostCode ) > -1 && ['94','95','96'].indexOf( prefixFromPostCode ) > -1 ){
          remote_area = 0
        }
        const sameProvince = this.checkSameProvince(item)
        // ***remark***
        // BKK = Bangkok Metropolitan Region กรุงเทพและปริมณฑล
        // เฉพาะ to, from vvvvvvv
        // 1 = กทม. BKK | 2 = ภาคกลาง C | 3 = เหนือ N | 4 = ภาคอีสาน NE | 5 = ภาคใต้ S
        // ********************************************************************************
        // เฉพาะ type vvvvvvv
        // 1 = within same province only [ N, NE, S ]
        // 2 = [ N, NE, S ] to BKK
        // 3 = N to [ C, NE, S ]
        // 4 = NE to [ C, N, S ]
        // 5 = S to [ C, N, NE ]
        // 6 = BKK to BKK
        // 7 = [ BKK, C ] to Not in BKK
        // 8 = within same province only C
        // 9 = C to BKK
        if( ![to, from].includes(1)
          && ![to, from].includes(2)
          && to === from
          && sameProvince
          && this.checkRuleDimensionWeight(FlashExpress.TYPE_SAME_PROVINCE_NOT_BKK, item)
        ){
          type = 1
        }else if( sameProvince && from === 2 && to === 2 ){
          type = 8
        }else if( ![1, 2].includes(from) && to === 1 ){
          type = 2
        }else if( from === 3 && [2, 4, 5].includes(to) ){
          type = 3
        }else if( from === 4 && [2, 3, 5].includes(to) ){
          type = 4
        }else if( from === 5 && [2, 3, 4].includes(to) ){
          type = 5
        }else if( from === 1 && to === 1 ){
          type = 6
        }else if( [1, 2].includes(from) && to !== 1 ){
          type = 7
        }else if( from === 2 && to === 1 ){
          type = 9
        }else{
          type = from
        }  
        console.log( 'type',type )
        return {
            rate_type : type ,
            rate_remote_area : remote_area ,
            cross_price : cross_price
        }
    }
    getZoneBefore_21_07_15( item ){
      let type , from , to
      let cross_price = 0
      let remote_area = 0
  
      remote_area = super.checkRemoteArea( Number(item.toPostcode) );
      
      let prefixFromPostCode = item.fromPostcode.toString().substring( 0 , 2 )
      let prefixToPostCode = item.toPostcode.toString().substring( 0 , 2 )
  
      // เฉพาะตอนโปร 9.9 FLE ถึง 27/12/2020
      if( Object.keys(item.courierRates).length < 2 ){
        from = null
        to = null
      }else{
        from = super.checkZone( prefixFromPostCode )
        to = super.checkZone( prefixToPostCode )
      }
  
      if( ['94','95','96'].indexOf( prefixToPostCode ) > -1 ){
        remote_area = this.listPostcodeSpecial[FlashExpress.CODE].remotearea.special.cost
      }
  
      if( ['94','95','96'].indexOf( prefixToPostCode ) > -1 && ['94','95','96'].indexOf( prefixFromPostCode ) > -1 ){
        remote_area = 0
      }
      // 1 = กทม. BKK | 2 = ภาคกลาง C |  
      if( to == 1 ){
        type = to
      }else if( Object.keys(item.courierRates).length > 5 
          && prefixFromPostCode == prefixToPostCode 
          && ( item.province.sameData == item.province.to 
          && item.source == 0 
          || item.province.from == item.province.to 
          && item.source == 1 ) 
          && ( item.weight < 19001 && item.culculateSize < 220 ) 
          && from != 2 && to != 2
      ){
        type = 6
      }else if( Object.keys(item.courierRates).length > 6 
              && prefixFromPostCode == prefixToPostCode 
              && from == 2 && to == 2 
              && ( item.province.sameData == item.province.to && item.source == 0 
              || item.province.from == item.province.to && item.source == 1 )
      ){
        type = 7
      }else if( from == 1 && to != 1 ){
        type = 2
      }else{
        type = from
      }  
  
      return {
          rate_type : type ,
          rate_remote_area : remote_area ,
          cross_price : cross_price
      }
    }
    checkRuleDimensionWeight( type, item ){
      const rule = FlashExpress.RULE_DIMENSION_WEIGHT[type]
      ? FlashExpress.RULE_DIMENSION_WEIGHT[type]
      : false
      if( !rule ) return rule
      return +item.weight < rule.max_weight && +item.culculateSize < rule.max_dimension
    }
    checkSameProvince( item ){
      return (!item.source && item.province.sameData == item.province.to ) || 
      ( item.source && item.province.from == item.province.to )
    }
    checkWeight( courierRates , item, validate ){
        item.index = courierRates.findIndex(rate => {
            return item.weight >= rate.min && item.weight <= rate.max
        })
        return super.checkRules( item , validate );
    }

    checkDimension( dimensionCourier , item , validate ){
        return super.checkCourierDimension( dimensionCourier , item , validate );
    }

    async checkRemoteAreaByCorrectorDest( addressRemote ){
      return new Promise(resolve => {
        super.getRemoteArea( addressRemote ).then( res => {
          if( res.status === 1 && ((res.data).hasOwnProperty('isRemote') 
              || (res.data).hasOwnProperty('isRemote100') )
              && res.data.isRemote.includes('flash') 
          ){
            resolve( true );
          }else if( res.status === 0 && res.data.length === 0 ){
            resolve( true );
          }else{
            resolve( false );
          }
        }) 
      })
    }

}